import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {finalize, map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';

import {VIDEO_API_URL, VIDEO_STORY_API_URL, VIDEO_CITY_API_URL} from '../../defines/protocol';
import {CITY2, isCity2} from "../../defines/gukeo.const";
import {SearchParam} from '../../defines/client.const';
import {generateUrlWithQueryParams} from '../../defines/client.func';
import {Video, VideoStory} from '../../models/video.model';
import {VideoLoader} from '../../interfaces/VideoLoader';
import {ApiService} from '../api/api.service';
import {NormalizeSearchKeyword} from '../../defines/search-keyword.func';


/**
 * 비디오는 아직 양이 많지 않아서 Pagenation을 사용하지 않는다.
 * TODO: 비디오의 양이 많아지면, 클라이언트의 화면 표시 정책을 정한 후 프로토콜도 수정해야 함.
 */
@Injectable({
  providedIn: 'root'
})
export class VideoService implements VideoLoader {
  protected urlApi = VIDEO_API_URL;

  private load$: Observable<Array<Video>> = null;

  public IsLoading(): boolean {
    return this.load$ !== null;
  }


  constructor(
    protected api: ApiService,
  ) { }

  public GetList(param?: SearchParam): Observable<Array<Video>>
  {
    if (this.load$) {
      console.warn('VideoService::GetList() already loading');
      return this.load$;
    }

    let url: string = null;
    if (param) {
      const keyword = NormalizeSearchKeyword(param.keyword);
      url = generateUrlWithQueryParams(
        this.urlApi,
        {
          ...('id' in param ? {id: param.id} : {}),
          ...(keyword ? {search: keyword} : {}),
          ...('limit' in param ? {limit: param.limit} : {}),
          ...('cat' in param ? {cat: param.cat} : {}),
          ...('story' in param ? {story: param.story} : {}),
          ...('city' in param ? {city: param.city} : {}),
        });
    }
    else {
      url = this.urlApi;
    }
    console.log('VideoService::GetList() url =', url, param);

    return this.load$ = this.api.Get(url)
      .pipe(
        finalize(() => {
          this.load$ = null;
        }),
        map((data: []) => {
          console.log('VideoService::GetList() param, data =', param, data);
          const result = new Array<Video>();
          data.forEach(value => result.push(new Video(value)));
          return result;
        })
      );
  }

  /**************************************************************************************************
   * Video Story 목록 받아오기
   **************************************************************************************************/
  public GetStoryList(): Observable<Array<VideoStory>>
  {
    return this.api.Get(VIDEO_STORY_API_URL).pipe(
      map((data: []) => {
        console.warn('VideoService::GetStoryList() data =', data);
        const result = new Array<VideoStory>();
        data.forEach(value => result.push(new VideoStory(value)));

        console.log('VideoService::GetStoryList() result =', result, data);
        return result;
      })
    );
  }

  public GetCityList(): Observable<Array<CITY2>> {
    return this.api.Get(VIDEO_CITY_API_URL).pipe(
      map((data: any[]) => {
        console.warn('VideoService::GetCityList() data =', data);
        const result = new Array<CITY2>();
        data.forEach(value => {
          if (isCity2(value)) {
            result.push(value);
          }
          else {
            console.error('VideoService::GetCityList() - 유효하지 않은 도시 데이터:', value);
          }
        });
        console.log('VideoService::GetCityList() result =', result);
        return result;
      })
    );
  }
}
